import { CITIES_IN_AZ, CITIES_IN_EN } from 'consts/cities'

export const getCityNamesByLang = (lang: string) => {
  if (lang === 'az') return CITIES_IN_AZ
  return CITIES_IN_EN
}
